import {endpoint} from "@/utils/api/Conf";
import {Places} from "@/types/Places";
import {SearchFilters} from "@/types/Search";

export const segmentPlacesRequest = async (segmentId: string, locale?: string, page: number = 1, page_size: number = 5): Promise<Places | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        "X-Language": locale || "it"
      }
    }
    return await fetch(endpoint + `segments/${segmentId}/places?page_size=${page_size}&page=${page}`, init)
      .then((response) => response.json())
      .then((data: Places) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const placesRequest = async (searchFilters?: SearchFilters, locale?: string): Promise<Places | false> => {
  try {
    let paramsString = ""
    const init: RequestInit = {
      method: "GET",
      headers: {
        "X-Language": locale || "it"
      }
    }
    if (searchFilters) {
      const paramsStrings: Array<string> = []
      if (searchFilters.search && searchFilters.search !== '') {
        paramsStrings.push(`search=${searchFilters.search}`)
      }
      if (searchFilters.type && searchFilters.type !== '') {
        paramsStrings.push(`type_id=${searchFilters.type}`)
      }
      if (searchFilters.category && searchFilters.category !== '') {
        paramsStrings.push(`category_id=${searchFilters.category}`)
      }
      if (searchFilters.segment && searchFilters.segment !== '') {
        paramsStrings.push(`segment_id=${searchFilters.segment}`)
      }
      if (searchFilters.page && searchFilters.page !== '') {
        paramsStrings.push(`page=${searchFilters.page}`)
      }
      if (searchFilters.page_size && searchFilters.page_size !== '') {
        paramsStrings.push(`page_size=${searchFilters.page_size}`)
      }
      if (searchFilters.latitude && searchFilters.latitude !== '') {
        paramsStrings.push(`latitude=${searchFilters.latitude}`)
      }
      if (searchFilters.longitude && searchFilters.longitude !== '') {
        paramsStrings.push(`longitude=${searchFilters.longitude}`)
      }
      if (searchFilters.radius && searchFilters.radius !== '') {
        paramsStrings.push(`radius=${searchFilters.radius}`)
      }
      if (paramsStrings.length > 0) {
        paramsString = '?' + paramsStrings.join('&')
      }
    }
    return await fetch(endpoint + `places` + paramsString, init)
      .then((response) => response.json())
      .then((data: Places) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
